const HTML_TAG_START = /<[a-zA-Z/!?]/;

export const containsHtmlTag = (value: unknown): boolean =>
  typeof value === 'string' && HTML_TAG_START.test(value);

export const fieldsWithHtmlTag = (
  values: Record<string, unknown> = {},
): string[] =>
  Object.keys(values).filter((key) => containsHtmlTag(values[key]));
